/**
 * ReportSummaryCards — totals summary row for Consignor Financials,
 * Net Proceeds, and Outstanding Receivables.
 * Stage 3 UI extraction from ReportsPage.js
 */
import React from 'react';
import { fmt } from '../../hooks/reports/reportConstants';

const SummaryCard = ({ label, value, color = '' }) => (
  <div className="p-4 rounded" style={{ backgroundColor: 'rgba(52, 107, 78, 0.1)' }}>
    <p className="text-xs text-muted-foreground">{label}</p>
    <p className={`text-xl font-bold ${color}`}>{fmt(value)}</p>
  </div>
);

const ReportSummaryCards = ({ activeReport, data, visibleCols }) => {
  if (!data) return null;

  if (activeReport === 'tenant-financials') return (
    <div className="flex gap-4 flex-wrap">
      {visibleCols.some(f => f.key === 'all_time_commissions') && <SummaryCard label="All-Time Commissions" value={data.total_all_time} color="text-primary" />}
      {visibleCols.some(f => f.key === 'ytd_commissions') && <SummaryCard label="YTD Commissions" value={data.total_ytd} color="text-primary" />}
      {visibleCols.some(f => f.key === 'all_time_revenue') && <SummaryCard label="All-Time Gross Sales" value={data.total_all_time_revenue} color="text-primary" />}
      {visibleCols.some(f => f.key === 'ytd_revenue') && <SummaryCard label="YTD Gross Sales" value={data.total_ytd_revenue} color="text-primary" />}
    </div>
  );

  if (activeReport === 'net-proceeds') return (
    <div className="flex gap-4 flex-wrap">
      <SummaryCard label="Gross Sales" value={data.total_sales} />
      <SummaryCard label="Total Net Proceeds" value={data.total_net_proceeds} color="text-primary" />
      {data.total_consignor_commissions != null && <SummaryCard label="Total Consignor Commissions" value={data.total_consignor_commissions} />}
      {data.total_owner_net_proceeds != null && <SummaryCard label="Owner's Net Proceeds" value={data.total_owner_net_proceeds} color="text-primary" />}
    </div>
  );

  if (activeReport === 'outstanding-receivables') return (
    <div className="flex gap-3">
      {[['Current', data.totals.current], ['30 Days', data.totals.days_30], ['60 Days', data.totals.days_60], ['90+ Days', data.totals.days_90_plus]].map(([label, val]) => (
        <div key={label} className="p-3 rounded" style={{ backgroundColor: val > 0 ? 'rgba(239, 68, 68, 0.1)' : 'rgba(52, 107, 78, 0.1)' }}>
          <p className="text-xs text-muted-foreground">{label}</p>
          <p className={`text-lg font-bold ${val > 0 ? 'text-red-600' : 'text-primary'}`}>{fmt(val)}</p>
        </div>
      ))}
      <div className="p-3 rounded bg-muted">
        <p className="text-xs text-muted-foreground">Total Outstanding</p>
        <p className="text-lg font-bold">{fmt(data.totals.total)}</p>
      </div>
    </div>
  );

  return null;
};

export default ReportSummaryCards;
